import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { PlanType } from '@zapier/design-system-revenue/src/types';

import { planStacks as PlanStacksQuery } from './types/planStacks';

export const planStacksQuery = gql`
  query planStacks {
    planStacks: pricingPageV3Plans {
      plans {
        amount
        id
        interval
        name
        tasks
        type
      }
      planType
    }
  }
`;

type Props = {
  planType: PlanType;
  skip: boolean;
};

export const usePlanStack = ({ planType, skip }: Props) => {
  const { data, error, loading } = useQuery<PlanStacksQuery>(planStacksQuery, {
    skip,
  });

  return {
    error: error
      ? 'There was an error fetching plan information. Please try again.'
      : null,
    isLoading: loading,
    planStack: data?.planStacks?.find(
      planStack => planStack.planType === planType
    ),
  };
};
